export function processClass(string) {
	return String(string).replace(/\.|\&|\#/g, '-')
}
